<ui-card class="approval-flows-container">
    <h2>{{ 'time-tracking.settings.approvalFlows' | appTranslate }}</h2>
    <h3>{{ 'time-tracking.settings.forHoursWithProjects' | appTranslate }}</h3>
    <div class="table-wrapper">
        <table class="ui table">
            <thead>
                <tr>
                    <th>{{ 'time-tracking.settings.name' | appTranslate }}</th>
                    <th>{{ 'time-tracking.settings.assignedProjects' | appTranslate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ 'time-tracking.approvalFlows.owner' | appTranslate }}</td>
                    <td>{{ ownerCount }}</td>
                </tr>
                <tr>
                    <td>{{ 'time-tracking.approvalFlows.manager' | appTranslate }}</td>
                    <td>{{ managerCount }}</td>
                </tr>
                <tr>
                    <td>{{ 'time-tracking.approvalFlows.automatic' | appTranslate }}</td>
                    <td>{{ automaticCount }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <h3>{{ 'time-tracking.settings.forHoursWithNoProjects' | appTranslate }}</h3>
    <div class="app-grid">
        <mat-form-field class="columns-4">
            <mat-label appRemoveAriaOwns>{{ 'time-tracking.settings.assignedApprovalFlow' | appTranslate }}</mat-label>
            <mat-select
                [(ngModel)]="approvalFlowNoProject"
                name="approvalFlow"
                (selectionChange)="onApprovalFlowChange()"
            >
                <mat-option *ngFor="let approvalFlow of approvalFlowsNoProject | keyvalue" [value]="approvalFlow.key">
                    {{ approvalFlow.value | appTranslate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</ui-card>
